import { ColGroupDef } from 'ag-grid-community'
import { ColumnType } from '../../../../containers/commons/AgGrid'
import { intl } from '../../../../../i18n'
import { GanttRowItem } from '../../../../containers/commons/AgGrid/components/cell/custom/gantt/type'
import { getGanttBarVisualTypeFromRowItem } from '../../../../containers/commons/AgGrid/components/cell/custom/gantt/ganttUtil'
import {
  ProgramManagementRow,
  ProgramManagementGridContext,
} from '../../programManagement'
import {
  AggregateField,
  WbsItemType,
} from '../../../../../domain/entity/WbsItemEntity'

const getProgressRate = (
  data: ProgramManagementRow,
  context: ProgramManagementGridContext
): number | undefined => {
  const progress = data.progress
  if (!progress) return undefined

  const isTask = context.aggregateTarget === WbsItemType.TASK
  const isCount = context.aggregateField === AggregateField.WBS_ITEM_COUNT
  const activeProgress = isTask
    ? isCount
      ? progress.taskCount
      : progress.taskWorkload
    : isCount
      ? progress.deliverableCount
      : progress.deliverableWorkload

  if (!activeProgress || activeProgress.total === 0) return undefined
  return activeProgress.completed / activeProgress.total
}

export const getGanttRowItem = (
  data: ProgramManagementRow,
  context?: ProgramManagementGridContext
): GanttRowItem | undefined => {
  if (!data) return undefined
  return {
    uuid: data.uuid,
    scheduledDate: data.scheduledDate,
    status: data.status,
    displayName: data.displayName,
    type: data.type,
    iconUrl: data.iconUrl,
    progressRate: context ? getProgressRate(data, context) : undefined,
  }
}

export const ganttColumnGroup: ColGroupDef = {
  headerName: intl.formatMessage({ id: 'projectOverview.ganttChart' }),
  headerGroupComponent: 'ganttHeaderGroupComponent',
  children: [
    {
      field: 'ganttChart',
      headerName: intl.formatMessage({ id: 'projectOverview.ganttChart' }),
      type: [ColumnType.gantt],
      cellRendererParams: {
        getGanttRowItem: (data: ProgramManagementRow) => getGanttRowItem(data),
        getVisualType: getGanttBarVisualTypeFromRowItem,
        readOnly: true,
      },
      width: 560,
      minWidth: 150,
      cellStyle: {
        borderColor: 'transparent',
      },
      valueGetter: params => {
        const data = params.data as ProgramManagementRow | undefined
        if (!data?.scheduledDate) return undefined
        const rowItem = getGanttRowItem(
          data,
          params.context as ProgramManagementGridContext
        )
        if (!rowItem) return undefined
        return JSON.stringify(rowItem)
      },
    },
  ],
}
